var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M107.595 79.46h-8.834A1.661 1.661 0 0 1 97.1 77.8v-9.935a.552.552 0 1 1 1.1 0V77.8a.554.554 0 0 0 .552.552h8.834a.554.554 0 0 0 .552-.552v-9.935a.552.552 0 1 1 1.1 0V77.8a1.661 1.661 0 0 1-1.643 1.66zm2.205-13.251h-3.865a.545.545 0 0 1-.386-.166l-.773-.773a.562.562 0 0 0-.414-.166h-2.4a.545.545 0 0 0-.386.166l-.773.773a.545.545 0 0 1-.386.166h-3.865a.552.552 0 1 1 0-1.1h3.648l.607-.607a1.605 1.605 0 0 1 1.187-.5h2.4a1.545 1.545 0 0 1 1.16.5l.607.607h3.639a.552.552 0 1 1 0 1.1z",
    transform: "translate(-92.936 -61.898)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "M368.552 265.939a.554.554 0 0 1-.552-.552v-8.834a.552.552 0 1 1 1.1 0v8.834a.554.554 0 0 1-.548.552zm3.865 0a.554.554 0 0 1-.552-.552v-8.834a.552.552 0 1 1 1.1 0v8.834a.554.554 0 0 1-.548.552z",
    transform: "translate(-360.243 -250.585)",
    style: {
      fill: "currentColor"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.5109a3d49cc9525dc94b23433c38235f.svg";
export { ForwardRef as ReactComponent };